import { ButtonMain } from '@remote-com/norma/core/button/Button.styled';
import { whenProp } from 'remote-com-shared/style/helpers';
import { sharedTransition } from 'remote-com-shared/style/motion';
import styled, { css } from 'styled-components';

import { fromBreakpointReference, untilBreakpointReference } from './shared';

export const StyledToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: -2px 0 -2px 6px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  color: inherit;
  background: none;
  border: none;

  ${fromBreakpointReference(css`
    display: none;
  `)}
`;

export const ToggleWrapper = styled.span`
  ${sharedTransition('height')}

  position: relative;
  width: 21px;
  height: 14px;
  display: block;
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  border-radius: 0;
  cursor: pointer;
  outline: none;
  flex-shrink: 0;
  z-index: 11;

  ${whenProp(
    '$isOpen',
    css`
      height: 23px;
    `
  )}
`;

export const ToggleLine = styled.span`
  ${sharedTransition('background-color')}

  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 2px;
  display: block;
  background-color: currentColor;
  border-radius: 25px;
  transition: all 0.15s cubic-bezier(0.445, 0.05, 0.55, 0.95),
    top 0.15s cubic-bezier(0.445, 0.05, 0.55, 0.95) 0.15s,
    opacity 0s cubic-bezier(0.445, 0.05, 0.55, 0.95) 0.15s;

  &:nth-of-type(2) {
    top: 6px;
  }
  &:nth-of-type(3) {
    top: 12px;
    width: 15px;
  }

  ${whenProp(
    '$isOpen',
    css`
      &:nth-of-type(1) {
        top: 0.7rem;
        transform: rotate(-45deg);
      }

      &:nth-of-type(2) {
        top: 0.7rem;
        opacity: 0;
      }

      &:nth-of-type(3) {
        width: 21px;
        top: 0.7rem;
        transform: rotate(45deg);
      }
    `
  )}
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;

  ${ButtonMain} {
    margin: -5px 0 -5px 6px;
  }
`;

export const CtaButtonToggle = styled.div`
  display: none;
  ${sharedTransition('opacity')}

  ${untilBreakpointReference(css`
    display: flex;
  `)}

  ${whenProp(
    '$isOpen',
    css`
      ${untilBreakpointReference(css`
        opacity: 0;
        pointer-events: none;
      `)}
    `
  )}
`;
